import { css } from 'lit';

import { medium, stacked } from '../media.js';

export const instancePageStyles = css`
  .sides {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    gap: var(--card-gap);
    align-items: stretch;
  }

  .sides .between {
    align-self: center;
    font-family: var(--font-display);
    font-weight: var(--font-display-weight);
    font-size: var(--font-size-2xl);
    color: var(--text-muted);
    letter-spacing: var(--font-display-tracking);
  }

  .sides .between[data-sync='false'] {
    color: var(--tone-progress);
  }

  .side h3 {
    margin: 0 0 var(--space-3);
    font-family: var(--font-mono);
    font-size: var(--font-size-2xs);
    font-weight: var(--font-weight-semibold);
    text-transform: uppercase;
    letter-spacing: var(--tracking-widest);
    color: var(--text-muted);
  }

  .side .number {
    font-family: var(--font-display);
    font-size: var(--font-size-3xl);
    font-weight: var(--font-display-weight);
    line-height: var(--line-height-tight);
    letter-spacing: var(--font-display-tracking);
    margin-bottom: var(--space-3);
  }

  @media ${medium} {
    .sides {
      grid-template-columns: minmax(0, 1fr);
    }

    .sides .between {
      transform: rotate(90deg);
      justify-self: center;
    }
  }

  .marker {
    margin-left: var(--space-2);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: var(--tracking-wide);
  }

  td.actions-cell {
    text-align: right;
  }

  td.actions-cell > * + * {
    margin-left: var(--space-1);
  }

  /* Rename and Add assistant, under the head. */
  .inline {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
    margin-bottom: var(--space-4);
  }

  .inline input,
  .inline select {
    flex: 1 1 var(--inline-field-min-width);
    width: auto;
  }

  .customer-choice {
    max-width: var(--form-width-sm);
  }

  .settings {
    margin-top: var(--section-gap);
  }

  .settings .field {
    margin-bottom: 0;
  }


  .secret-form {
    display: flex;
    gap: var(--space-2);
    align-items: center;
  }

  .secret-form input {
    flex: 1;
    min-width: 0;
  }

  /* The form takes a row of its own: in the narrow column it would push the table sideways. */
  tr.editing td {
    border-bottom: none;
  }

  .revisions {
    margin-top: var(--space-6);
  }

  .columns {
    display: grid;
    gap: var(--column-gap);
    grid-template-columns: var(--columns-main-aside);
    align-items: start;
    margin-top: var(--column-gap);
  }

  @media ${stacked} {
    .columns {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .columns section + section {
    margin-top: 0;
  }
`;
